export type ExpectedChildOutput = {
  count: number;
  offset: number;
  endExclusive: number;
};

/** Bind the refetched artifact to the exact child output admitted by its batch. */
export function validateChildOutput(
  organizationId: number,
  request: { id: number; expectedChildOutput?: ExpectedChildOutput },
  run: Record<string, unknown> | null | undefined,
): void {
  const expected = request.expectedChildOutput;
  if (!expected) return;
  const range = run?.range;
  const qrs = run?.qrs;
  if (!run || run.id !== request.id || run.organizationId !== organizationId
    || run.sourceName !== 'Multi-Package Print'
    || !Number.isSafeInteger(expected.count) || expected.count <= 0
    || !Number.isSafeInteger(expected.offset) || expected.offset < 0
    || expected.endExclusive !== expected.offset + expected.count
    || run.count !== expected.count || run.offset !== expected.offset
    || !Array.isArray(range) || range.length !== 1 || !Array.isArray(range[0])
    || range[0][0] !== expected.offset || range[0][1] !== expected.endExclusive - 1
    || !Array.isArray(qrs) || qrs.length !== expected.count
    || qrs.some((qr) => typeof qr !== 'string' || !qr)) {
    throw new Error('Print run does not match the completed child output manifest');
  }
}
